const MergeButton = () => {
	return <div>MergeButton</div>;
};

export default MergeButton;
